<template>
	<v-text-field
		v-model="searchValue"
		:placeholder="placeholder"
		outlined
		dense
		@input="onInput"
		prepend-inner-icon="mdi-magnify"
		class="font-14"
		hide-details
	></v-text-field>
</template>

<script>
import _ from 'lodash';
export default {
	name: 'Search',
	props: {
		placeholder: {
			type: String,
			default: 'Szukaj...'
		}
	},
	data() {
		return {
			searchValue: "",
		};
	},
	methods: {
		onInput(v) {
			this.$emit('input', v);
		}
	},
	created() {
		this.onInput = _.debounce(this.onInput, 300);
	}
};
</script>
